/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import type {RuleFeatures, RulesetTarget, UITargetDefinition} from '../types/rules-types'

export type AppPayloadWithFeatures = {supported_features?: RuleFeatures}

export const useRuleFeatures = () =>
  useAppPayload<AppPayloadWithFeatures>()?.supported_features ?? {
    historyEnabled: false,
    importExportEnabled: false,
    supportedTargets: ['branch', 'tag'],
    targetDefinitions: {} as Record<RulesetTarget, UITargetDefinition>,
    listViewEnabled: true,
  }
